// src/components/HomeSplash.jsx
import React from "react";

export default function HomeSplash({ show, topOffset = 0, zIndex = 40 }) {
  if (!show) return null;

  return (
    <div
      className={`fixed left-0 right-0 bottom-0 bg-gray-200 flex items-center justify-center`}
      style={{ top: topOffset, zIndex }}
    >
      <div className="flex flex-col items-center gap-4">
        <img
          src="/Logo_EKINE.png"
          alt="EKINE"
          className="h-20 sm:h-24 w-auto object-contain animate-ekinePop select-none"
          draggable="false"
        />
      </div>

      <style>{`
        @keyframes ekinePop {
          0%   { transform: scale(0.85); opacity: 0; }
          60%  { transform: scale(1.05); opacity: 1; }
          100% { transform: scale(1.00); opacity: 1; }
        }
        .animate-ekinePop {
          animation: ekinePop 2000ms ease-out forwards;
        }
      `}</style>
    </div>
  );
}
